import "./Footer.css";

function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <a href="https://www.facebook.com/lucasayacob" target="aboutblank">
                    <img src="/img/facebook.png" alt="logo de facebook" />
                </a>
                <a href="https://www.instagram.com/lucas_yacob/" target="aboutblank">
                    <img src="/img/instagram.png" alt="logo de instagram" />
                </a >
                <a href="https://twitter.com/LucasYacob" target="aboutblank">
                    <img src="/img/gorjeo.png" alt="logo de twitter" />
                </a >
            </div>
        </footer>
    )
}

export default Footer;
